import { UseMutationOptions, useQueryClient } from '@tanstack/react-query';

import MutationKeys from 'hooks/mutations/keys';
import useMutation from 'hooks/useMutation';
import { ApiMethods, CuredApiPaths } from 'models/enums';

import type { CreateRoleInput, CreateRoleApiResponse } from 'domains/accessCentre/types';

/** POST /roles — create a new custom role */
const useCreateRole = (mutateOptions?: UseMutationOptions<CreateRoleApiResponse, Error, CreateRoleInput>) => {
    const queryClient = useQueryClient();
    const { onSuccess: onSuccessOption, ...restMutateOptions } = mutateOptions ?? {};

    return useMutation<CreateRoleInput, CreateRoleApiResponse>(
        MutationKeys.CREATE_ROLE,
        CuredApiPaths.ACCESS_CENTRE_ROLES,
        {
            onSuccess: (data, variables, context) => {
                queryClient.invalidateQueries(['access-centre', 'roles']);
                onSuccessOption?.(data, variables, context);
            },
            ...restMutateOptions,
        },
        ApiMethods.POST
    );
};

export default useCreateRole;
